import React from "react";
import "./style.css";
import Header from "./Components/Header";
import Team from "./Components/Team";
import Footer from "./Components/Footer";
import Services from "./Components/Services";
import Discount from "./Components/Discount";
import Ourwork from "./Components/Ourwork";
import Pricing from "./Components/Pricing";
import Achievement from "./Components/Achievement";
import Appointment from "./Components/Appointment";
import BackImage1 from "./Images/bg_1.jpg";
import partner1 from "./Images/partner-1.jpg";
import partner2 from "./Images/partner-2.jpg";
import partner3 from "./Images/partner-3.jpg";
import partner4 from "./Images/partner-4.jpg";
import "./Components/flaticon.css";
import Welcome from "./Components/Welcome";
import Testimonial from "./Components/Testimonial";
import Gallery from "./Components/Gallery";
import Offer from "./Components/Offer";
import Loader from "./Components/Loader";
import PopOffer from "./Components/Popoffer";
import Welcome2 from "./Components/Welcome2";

const Homepage=()=>{
    return(
        <>
  <title>JanuShree - Free Bootstrap 4 Template by Colorlib</title>
  <meta charSet="utf-8" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1, shrink-to-fit=no"
  />
  <link
    href="https://fonts.googleapis.com/css?family=Montserrat:300,400,600,700"
    rel="stylesheet"
  />
  <link rel="stylesheet" href="css/open-iconic-bootstrap.min.css" />
  <link rel="stylesheet" href="css/animate.css" />
  <link rel="stylesheet" href="css/owl.carousel.min.css" />
  <link rel="stylesheet" href="css/owl.theme.default.min.css" />
  <link rel="stylesheet" href="css/magnific-popup.css" />
  <link rel="stylesheet" href="css/aos.css" />
  <link rel="stylesheet" href="css/ionicons.min.css" />
  <link rel="stylesheet" href="css/bootstrap-datepicker.css" />
  <link rel="stylesheet" href="css/jquery.timepicker.css" />
  <link rel="stylesheet" href="css/flaticon.css" />
  <link rel="stylesheet" href="css/icomoon.css" />
  <link rel="stylesheet" href="css/style.css" />
  {/* <div
    className="hero-wrap js-fullheight"
    style={{ backgroundImage: `url(${BackImage1})` }}
    data-stellar-background-ratio="0.5"
  >
    <div className="overlay" />
    <div className="container">
      <div
        className="row no-gutters slider-text js-fullheight align-items-center justify-content-center"
        data-scrollax-parent="true"
      >
        <div
          className="col-md-8 ftco-animate text-center"
          data-scrollax=" properties: { translateY: '70%' }"
        >
          <div className="icon">
            <a href="index.html" className="logo">
              <span className="flaticon-flower" />
              <h1>JanuShree</h1>
            </a>
          </div>
          <h1
            className="mb-4"
            data-scrollax="properties: { translateY: '30%', opacity: 1.6 }"
          >
            Beauty Salon
          </h1>
          <p
            className="mb-5"
            data-scrollax="properties: { translateY: '30%', opacity: 1.6 }"
          >
            Created by <a href="#">DATADNA</a>
          </p>
          <p data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
            <a
              href="https://vimeo.com/45830194"
              className="btn btn-white btn-outline-white px-4 py-3"
            >
              View Our Services
            </a>
          </p>
        </div>
      </div>
    </div>
  </div> */}
  <Header/>
  <Welcome2/>
  {/* <Welcome/> */}
  {/* END nav */}
  <Services/>
  {/* <Team/> */}
  <Ourwork/>
  
  <section className="ftco-partner ftco-brandsection">
    <div className="container">
      <div className="row partner justify-content-center">
      <h2 className="mb-4 blackthemegradient">Our Beauty Products</h2>
        <div className="col-md-10">
          <div className="row">
            <div className="col-md-3 ftco-animate">
              <a href="#" className="partner-entry">
                <img
                  src={partner1}
                  className="img-fluid"
                  alt="Colorlib template"
                />
              </a>
            </div>
            <div className="col-md-3 ftco-animate">
              <a href="#" className="partner-entry">
                <img
                  src={partner2}
                  className="img-fluid"
                  alt="Colorlib template"
                />
              </a>
            </div>
            <div className="col-md-3 ftco-animate">
              <a href="#" className="partner-entry">
                <img
                  src={partner3}
                  className="img-fluid"
                  alt="Colorlib template"
                />
              </a>
            </div>
            <div className="col-md-3 ftco-animate">
              <a href="#" className="partner-entry">
                <img
                  src={partner4}
                  className="img-fluid"
                  alt="Colorlib template"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* <Offer/> */}
  <Gallery/>
  <Achievement/>
  <Testimonial/>
 <Appointment/>
 <Loader/>
 {/* <PopOffer/> */}
  <Footer/>
  {/* loader */}
  {/* <div id="ftco-loader" className="show fullscreen">
    <svg className="circular" width="48px" height="48px">
      <circle
        className="path-bg"
        cx={24}
        cy={24}
        r={22}
        fill="none"
        strokeWidth={4}
        stroke="#eeeeee"
      />
      <circle
        className="path"
        cx={24}
        cy={24}
        r={22}
        fill="none"
        strokeWidth={4}
        strokeMiterlimit={10}
        stroke="#F96D00"
      />
    </svg>
  </div> */}
</>

    );
}

export default Homepage;